import React from "react";
import SEO from "../components/SEO";
import LegalShell from "../components/LegalShell";

export default function MentionsLegales() {
  return (
    <LegalShell eyebrow="Légal" title="Mentions légales" lastUpdate="29 avril 2026" testid="page-mentions">
      <SEO
        title="Mentions légales · MetaConnect"
        description="Mentions légales du site metaconnect.fr conformément à la loi pour la confiance dans l'économie numérique (LCEN)."
        canonical="/mentions-legales"
      />

      <h2>1. Éditeur du site</h2>
      <p>
        Le site <strong>metaconnect.fr</strong> est édité par&nbsp;:
      </p>
      <ul>
        <li><strong>Raison sociale</strong> : METACONNECT.FR</li>
        <li><strong>Forme juridique</strong> : Société par Actions Simplifiée (SAS)</li>
        <li><strong>Capital social</strong> : 1 000 €</li>
        <li><strong>Siège social</strong> : 68 route de la Ferté-Saint-Aubin, 45150 Jargeau, France</li>
        <li><strong>RCS</strong> : Orléans 931 999 833</li>
        <li><strong>SIREN</strong> : 931 999 833 — <strong>SIRET</strong> : 931 999 833 00011</li>
        <li><strong>Code APE</strong> : 62.01Z (Programmation informatique)</li>
        <li><strong>N° TVA intracommunautaire</strong> : FR22 931 999 833</li>
        <li><strong>Email de contact</strong> : <a href="mailto:contact@metaconnect.fr">contact@metaconnect.fr</a></li>
        <li><strong>Téléphone</strong> : 01 89 70 97 49</li>
      </ul>

      <h2>2. Directeur de la publication</h2>
      <p>
        Le directeur de la publication est <strong>Monsieur Benoît Tommasino</strong>, en
        qualité de Président de la SAS METACONNECT.FR.
      </p>

      <h2>3. Hébergement du site</h2>
      <p>
        Le site est hébergé par&nbsp;:
      </p>
      <ul>
        <li>
          <strong>Plateforme applicative</strong>&nbsp;: Emergent (emergent.sh), opérée par
          Emergent Agi Inc., délivrant le rendu via un CDN Cloudflare. Toute information
          technique est disponible sur le site officiel <a href="https://emergent.sh" target="_blank" rel="noreferrer">emergent.sh</a>.
        </li>
        <li>
          <strong>Hébergeur du nom de domaine</strong>&nbsp;: OVH SAS — 2 rue Kellermann,
          59100 Roubaix, France — RCS Lille Métropole 424 761 419 — Tél&nbsp;: +33 9 72 10 10 07 —
          <a href="https://www.ovhcloud.com" target="_blank" rel="noreferrer"> www.ovhcloud.com</a>.
        </li>
      </ul>
      <p>
        Les données de santé éventuellement traitées dans le cadre des services MetaConnect sont
        hébergées en France auprès d'un hébergeur certifié <strong>HDS</strong> (Hébergeur de
        Données de Santé) conformément à l'article L.1111-8 du Code de la santé publique.
      </p>

      <h2>4. Propriété intellectuelle</h2>
      <p>
        L'ensemble des éléments du site metaconnect.fr (textes, illustrations, logos, marques,
        bases de données, code source) est protégé par les dispositions du Code de la propriété
        intellectuelle. Toute reproduction, représentation, modification, diffusion, totale ou
        partielle, est interdite sans l'autorisation écrite préalable de l'éditeur, sauf
        exceptions prévues par la loi (notamment courte citation).
      </p>
      <p>
        Les marques citées appartenant à des tiers (INS, DMP, MSSanté, Pro Santé Connect, e-CPS, HDS,
        Mon Espace Santé, etc.) sont la propriété de leurs détenteurs respectifs et sont mentionnées
        à des fins exclusivement informatives.
      </p>

      <h2>5. Liens hypertextes</h2>
      <p>
        Le site peut contenir des liens vers des sites tiers (par exemple esante.gouv.fr, has-sante.fr,
        cnil.fr). MetaConnect n'exerce aucun contrôle sur ces sites et ne saurait être tenu pour
        responsable de leur contenu, de leur disponibilité ou de leur politique de confidentialité.
      </p>

      <h2>6. Responsabilité</h2>
      <p>
        MetaConnect met tout en œuvre pour fournir des informations exactes et à jour. Toutefois,
        l'éditeur ne saurait garantir l'exactitude, la complétude ou l'actualité des informations
        diffusées sur le site, qui ne constituent en aucun cas un conseil professionnel ou juridique.
      </p>

      <h2>7. Données personnelles &amp; cookies</h2>
      <p>
        Les modalités de collecte et de traitement de vos données personnelles sont décrites dans
        notre <a href="/donnees">Charte de protection des données</a>, conforme au Règlement Général
        sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
      </p>

      <h2>8. Droit applicable &amp; juridiction</h2>
      <p>
        Les présentes mentions légales sont régies par le droit français. En cas de litige, et à
        défaut de résolution amiable, les tribunaux d'<strong>Orléans</strong> seront seuls
        compétents.
      </p>
    </LegalShell>
  );
}
